import { AnnotationComponentProps } from "@routes/Article/components/StoryElements/Annotation/utils/types";

export default function AnnotationComponentSuperscript({
  children,
}: AnnotationComponentProps): React.ReactElement {
  return <sup>{children}</sup>;
}
